import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import { apiSlice } from './slices/apiSlice';
import tokenReducer from './slices/token';
import schemaReducer from './slices/schema';
import globalExportReducer from './slices/globalExport';
import idsInMapReducer from './slices/idsInMap';
import filtersInMapReducer from './slices/filtersInMap';
import listDataIgnoreDateReducer from './slices/listDataIgnoreDate';
import refreshReducer from './slices/refreshSlice';
import globalDateReducer from './slices/globalDateSlice';
// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['listDataIgnoreDate'],
  blacklist: [apiSlice.reducerPath],
};

export const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  kanban: kanbanReducer,
  product: persistReducer(productPersistConfig, productReducer),
  [apiSlice.reducerPath]: apiSlice.reducer,
  token: tokenReducer,
  schema: schemaReducer,
  globalExport: globalExportReducer,
  idsInMap: idsInMapReducer,
  filtersInMap: filtersInMapReducer,
  listDataIgnoreDate: listDataIgnoreDateReducer,
  refresh: refreshReducer,
  // intentionally not persisted - it only describes the currently mounted view
  globalDate: globalDateReducer,
});

export default rootReducer;
